// ============================================================
// AppAvatar — User Avatar with Fallback Initials
// ============================================================

import { Avatar } from '@mui/material';
import { tokens } from '@/theme/tokens';

function getInitials(name) {
  if (!name) return '?';
  const parts = name.trim().split(' ');
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function AppAvatar({ name, src, size = 40, sx = {}, ...props }) {
  return (
    <Avatar
      src={src}
      alt={name}
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.4,
        fontWeight: tokens.typography.fontWeights.semiBold,
        backgroundColor: tokens.colors.primary.main,
        color: tokens.colors.primary.contrastText,
        ...sx,
      }}
      {...props}
    >
      {!src && getInitials(name)}
    </Avatar>
  );
}
